export default __webpack_public_path__ + "static/media/ArrowBlue.6250637f.svg";